<template>
  <div>
    <header-slot>
      <template v-slot:content-right>
        <div class="h-100">
          <b-button
            v-if="routeName == 'operations-service-orders-list'"
            v-b-tooltip.hover.left
            :title="$t('Add Service Order')"
            variant="outline-success"
            @click="openAddServiceOrderModal"
          >
            <!-- <feather-icon icon="PlusIcon"></feather-icon> -->
            {{ $t("Create service") }}
          </b-button>
        </div>
      </template>
    </header-slot>

    <b-nav card-header pills class="m-0">
      <b-nav-item
        v-for="(item, index) in tabs"
        :key="index"
        :to="{ name: item.name }"
        exact
        exact-active-class="active"
        :link-classes="['px-3', bgTabsNavs]"
        >{{ $t(item.title) }}
      </b-nav-item>
    </b-nav>

    <b-card
      no-body
      class="border-top-primary border-3 border-table-radius px-0"
    >
      <router-view ref="routerViewTab" :key="routeName" />
    </b-card>

    <AddServiceOrderModal
      v-if="showAddServiceOrderModal"
      @close="showAddServiceOrderModal = false"
      @save="
        (showAddServiceOrderModal = false),
          $refs.routerViewTab.$refs['ref-service-orders-table'].refresh()
      "
    />
  </div>
</template>

<script>
import AddServiceOrderModal from "@/views/operations/views/service-orders/components/AddServiceOrderModal.vue";
export default {
  name: "ServiceOrders",
  components: {
    AddServiceOrderModal,
  },
  data() {
    return {
      showAddServiceOrderModal: false,
    };
  },
  computed: {
    tabs() {
      return this.$route.matched[1].meta.tabs;
    },
    routeName() {
      return this.$route.name;
    },
  },
  methods: {
    openAddServiceOrderModal() {
      this.showAddServiceOrderModal = true;
    },
  },
};
</script>
<style>
</style>